import React, { createContext, useContext, useState, useCallback } from 'react';

const PageContext = createContext();

export const usePageContext = () => {
    const context = useContext(PageContext);
    if (!context) {
        throw new Error('usePageContext must be used within a PageProvider');
    }
    return context;
};

export const PageProvider = ({ children }) => {
    const [breadcrumbItems, setBreadcrumbItems] = useState([]);
    const [backUrl, setBackUrl] = useState(null);

    const setBreadcrumb = useCallback((items, url) => {
        setBreadcrumbItems(items || []);
        setBackUrl(url || null);
    }, []);

    const clearBreadcrumb = useCallback(() => {
        setBreadcrumbItems([]);
        setBackUrl(null);
    }, []);

    const value = {
        breadcrumbItems,
        backUrl,
        setBreadcrumb,
        clearBreadcrumb,
        hasBreadcrumb: breadcrumbItems.length > 0
    };

    return (
        <PageContext.Provider value={value}>
            {children}
        </PageContext.Provider>
    );
};

export default PageContext;
